import type { AdminRole, CrudAction, ModulePermission } from '@/core/auth/types';

const ACTION_FIELD: Record<CrudAction, keyof ModulePermission> = {
  create: 'can_create',
  read: 'can_read',
  update: 'can_update',
  delete: 'can_delete',
};

/** Fail-closed: no matching module permission => not allowed. */
export function hasPermission(
  permissions: ModulePermission[],
  module: string,
  action: CrudAction,
): boolean {
  const entry = permissions.find((p) => p.module === module);
  if (!entry) return false;
  return Boolean(entry[ACTION_FIELD[action]]);
}

export const WEB_ALLOWED_ROLES: AdminRole[] = ['SUPER_ADMIN', 'TECH_ADMIN'];

export const isWebAllowedRole = (role: AdminRole | null): boolean =>
  role !== null && WEB_ALLOWED_ROLES.includes(role);
